import instance from '../Axios';
import { ApiUrls } from '@/service/constants/urls';
import { TReviewsResponse } from '@/domain/Reviews.domain';
import { replaceLightframe } from '@/service/utils/replaceLightframe';

type TReviewParams = {
    trip_id: string | number;
    partner_id: string;
    limit: number;
    offset?: number;
};

export const getReviews = ({
    trip_id,
    partner_id,
    limit,
    offset,
}: TReviewParams): Promise<TReviewsResponse> => {
    return instance
        .get<TReviewsResponse>(`${ApiUrls.reviews.root}/${trip_id}/${offset}/${limit}`, {
            params: { partnerId: replaceLightframe(partner_id) },
        })
        .then(({ data }) => data);
};
